import SessionEventProto from "../session-event-proto";
import Company from "../../model2/company/company";
import {SESSION_COMPANY_PROFILE_CHANGE} from "../../gd/bus/bus-event-type";

export default class SessionEvent_CompanyChange extends SessionEventProto {


    constructor(sessionEvent:any) {
        super(sessionEvent)
    }


    process() {

        const sessionCompany = gd.session.companies.get(this.data.id)
        if (!sessionCompany) return

        const tempCompany = new Company(this.data); // required for proper color and abbreviation parse

        sessionCompany.name         = tempCompany.name
        sessionCompany.icon         = tempCompany.icon
        sessionCompany.settings     = tempCompany.settings
        sessionCompany.finance      = tempCompany.finance
        sessionCompany.workWeek     = tempCompany.settings.workSchedule.workWeek
        sessionCompany.color        = tempCompany.color
        sessionCompany.abbreviation = tempCompany.abbreviation


        gd.bus.triggerEvent(SESSION_COMPANY_PROFILE_CHANGE);

    }
}


